import * as React from 'react';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  DialogContentText
} from '@material-ui/core';
import Button from '@material-ui/core/Button';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';
import { Checkbox, FormControlLabel } from '@material-ui/core';

const styles: StyleRulesCallback = theme => ({});

interface Props {
  onClose: () => void;
  open: boolean;
}

interface State {
  accepted: boolean;
}

const TocLink = () => <a href="#">terminos y condiciones</a>;

class BetaDialog extends React.Component<Props & WithStyles, State> {
  state = {
    accepted: false
  };

  handleClose = () => {
    this.setState({ accepted: false });
    this.props.onClose();
  }

  render() {
    const { open } = this.props;
    const { accepted } = this.state;
    return (
      <Dialog
        open={open}
        onClose={this.handleClose}
        onBackdropClick={this.handleClose}
        onEscapeKeyDown={this.handleClose}
      >
        <DialogTitle>Funcionalidad BETA</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Esta funcionalidad se encuentra en estado <strong>beta</strong>,
            esto significa que todavia esta en desarrollo y puede ser modificada
            sin previo aviso. Si desea utilizarla de todas formas, debe aceptar
            los&nbsp;<TocLink />&nbsp;y solicitar acceso. Nuestro esquipo de
            soporte evaluara su solictitud y se pondra en contacto.
          </DialogContentText>
          <FormControlLabel
            control={
              <Checkbox
                checked={accepted}
                onChange={() => this.setState({ accepted: !accepted })}
              />
            }
            label="He leido y acepto los terminos y condiciones"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleClose} disabled={!accepted} color="primary">
            Solicitar Acceso
          </Button>
          <Button onClick={this.handleClose}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(BetaDialog);



// WEBPACK FOOTER //
// ./src/containers/BetaDialog.tsx